"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.normalizeClientMInfo = exports.normalizeClientGInfo = void 0;

var normalizeDocType = function normalizeDocType(legadoDocType) {
  var docTypeObject = {};
  docTypeObject.docTypeCode = -1;
  docTypeObject.docTypeText = null;

  if (legadoDocType.toLowerCase() === 'd') {
    docTypeObject.docTypeCode = 1;
    docTypeObject.docTypeText = 'NIF';
  } else if (legadoDocType.toLowerCase() === 'l') {
    docTypeObject.docTypeCode = 2;
    docTypeObject.docTypeText = 'CIF';
  } else if (legadoDocType.toLowerCase() === 'r') {
    docTypeObject.docTypeCode = 3;
    docTypeObject.docTypeText = 'NIE';
  } else if (legadoDocType.toLowerCase() === 'p') {
    docTypeObject.docTypeCode = 4;
    docTypeObject.docTypeText = 'Pasaporte';
  }

  return docTypeObject;
};

var normalizeClientGInfo = function normalizeClientGInfo(infoCliente) {
  var clientInfo = null;

  if (infoCliente.datosClienteG) {
    // Caso de clientes con tarjeta de residencia, reseteamos el valor del apellido2 a vacío.
    if (infoCliente.datosClienteG.apellido2 === '.' || infoCliente.datosClienteG.apellido2 === '/') {
      infoCliente.datosClienteG.apellido2 = '';
    }

    clientInfo = {
      name: infoCliente.datosUsuarioAut.nombre,
      firstSurname: infoCliente.datosClienteG.apellido1,
      secondSurname: infoCliente.datosClienteG.apellido2,
      docType: normalizeDocType(infoCliente.datosClienteG.tipDoc).docTypeCode,
      docTypeText: normalizeDocType(infoCliente.datosClienteG.tipDoc).docTypeText,
      businessName: infoCliente.datosClienteG.razonSocial,
      segment: infoCliente.datosClienteG.segmentoGlobal,
      subsegment: infoCliente.datosClienteG.subSegmentoGlobal,
      email: infoCliente.datosUsuarioAut.email,
      // eslint-disable-next-line max-len
      docNumber: infoCliente.datosClienteG.numDoc.substring(infoCliente.datosClienteG.numDoc.length - 9, infoCliente.datosClienteG.numDoc.length),
      // eslint-disable-next-line max-len
      adminName: "".concat(infoCliente.datosUsuarioAut.nombre, " ").concat(infoCliente.datosUsuarioAut.apellido1, " ").concat(infoCliente.datosUsuarioAut.apellido2),
      cuc: infoCliente.datosUsuarioAut.cuc
    };
  }

  return clientInfo;
};

exports.normalizeClientGInfo = normalizeClientGInfo;

var normalizeClientMInfo = function normalizeClientMInfo(infoCliente) {
  var billingInfo = infoCliente.cliente.dirFact;
  var shippingInfo = infoCliente.cliente.dirEnvio;
  var clientInfo = null;

  if (billingInfo && shippingInfo) {
    clientInfo = {
      shippingAddress: {
        provinceCode: shippingInfo.codigoProvincia,
        provinceDescription: shippingInfo.descProvincia,
        townCode: shippingInfo.codigoPoblacion,
        townName: shippingInfo.nombrePoblacionMunicipio,
        streetCode: shippingInfo.codigoCalle,
        streetName: shippingInfo.nombreCalle,
        streetDescriptionCode: shippingInfo.codigoTipoVia,
        streetDescription: shippingInfo.descripcionTipoVia,
        streetNumberDescriptionCode: shippingInfo.codTipoNumero,
        streetNumberDescription: shippingInfo.descTipoNumero,
        streetNumber: shippingInfo.numeroCalle,
        addressLeft: shippingInfo.restoNumeroCalle,
        postalCode: shippingInfo.codigoPostal
      },
      billingAddress: {
        provinceCode: billingInfo.codigoProvincia,
        provinceDescription: billingInfo.descProvincia,
        townCode: billingInfo.codigoPoblacion,
        townName: billingInfo.nombrePoblacionMunicipio,
        streetCode: billingInfo.codigoCalle,
        streetName: billingInfo.nombreCalle,
        streetDescriptionCode: billingInfo.codigoTipoVia,
        streetDescription: billingInfo.descripcionTipoVia,
        streetNumberDescriptionCode: billingInfo.codTipoNumero,
        streetNumberDescription: billingInfo.descTipoNumero,
        streetNumber: billingInfo.numeroCalle,
        addressLeft: billingInfo.restoNumeroCalle,
        postalCode: billingInfo.codigoPostal
      }
    };
  }

  return clientInfo;
};

exports.normalizeClientMInfo = normalizeClientMInfo;

//# sourceMappingURL=clientNormalizer.js.map